import { create } from "zustand";
import useApi from "../helper/apiConfig";
import { apiRoutes } from "../helper/constant";

export const useInstanceKYCStore = create((set) => ({
  // get instance kyc data
  instanceKYCData: null,
  isInstanceKYCLoading: false,
  isInstanceKYCError: false,
  isInstanceKYCSuccess: false,

  // post instance kyc data
  postInstanceKYCData: null,
  isPostInstanceKYCLoading: false,
  isPostInstanceKYCError: false,
  isPostInstanceKYCSuccess: false,

  groupsData: null,
  groupsDataLoading: false,
  groupsDataError: false,
  groupsDataSuccess: false,

  setState: (newState) => set((state) => ({ ...state, ...newState })),
}));

// Fetch Instance KYC
export const useFetchInstanceKYC = () => {
  const instanceKYCApi = useApi(process.env.REACT_APP_BASE_URL);
  const { setState } = useInstanceKYCStore();

  const fetchInstanceKYC = async () => {
    setState({
      isInstanceKYCLoading: true,
      isInstanceKYCError: false,
      isInstanceKYCSuccess: false,
    });

    try {
      const response = await instanceKYCApi.get(
        `${apiRoutes.instanceKYC.instanceKYC}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
            instanceid: `${sessionStorage.getItem("instanceId")}`,
          },
        }
      );
      const { data: instanceKYCData } = response;
      setState({
        instanceKYCData: instanceKYCData,
        isInstanceKYCSuccess: true,
      });
    } catch (error) {
      setState({ isInstanceKYCError: true });
      console.error("Failed to fetch data:", error);
    } finally {
      setState({ isInstanceKYCLoading: false });
    }
  };

  return fetchInstanceKYC;
};

// Post Instance KYC
export const usePostInstanceKYC = () => {
  const instanceKYCApi = useApi(process.env.REACT_APP_BASE_URL);
  const { setState } = useInstanceKYCStore();

  const postInstanceKYC = async (data) => {
    setState({
      isPostInstanceKYCLoading: true,
      isPostInstanceKYCError: false,
      isPostInstanceKYCSuccess: false,
    });

    try {
      const response = await instanceKYCApi.post(
        `${apiRoutes.instanceKYC.instanceKYC}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
            instanceid: `${sessionStorage.getItem("instanceId")}`,
          },
        }
      );
      const { data: instanceKYCData } = response;
      setState({
        postInstanceKYCData: instanceKYCData,
        isPostInstanceKYCSuccess: true,
      });
    } catch (error) {
      setState({ isPostInstanceKYCError: true });
      console.error("Failed to fetch data:", error);
    } finally {
      setState({ isPostInstanceKYCLoading: false });
    }
  };

  return postInstanceKYC;
};

export const useGroupData = () => {
  const instanceKYCApi = useApi(process.env.REACT_APP_BASE_URL_V5);
  const { setState } = useInstanceKYCStore();

  const fetchGroupData = async () => {
    setState({
      groupsDataLoading: true,
      groupsDataError: false,
      groupsDataSuccess: false,
    });

    try {
      const response = await instanceKYCApi.get(
        `${apiRoutes.instanceKYC.getGroupsData}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
            instanceid: `${sessionStorage.getItem("instanceId")}`,
          },
        }
      );
      const { data: groupsData } = response;
      setState({
        groupsData: groupsData,
        groupsDataSuccess: true,
      });
    } catch (error) {
      setState({ groupsDataError: true });
      console.error("Failed to fetch data:", error);
    } finally {
      setState({ groupsDataLoading: false });
    }
  };

  return fetchGroupData;
};


